import styled, { keyframes } from 'styled-components';
import colors from '../../assets/styles/colors';

const rotating = keyframes`
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  
  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
`;

export const ModalActionAddressContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: ${colors.bgOverlay};
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: .2s;
  opacity: ${prop => prop.open ? '1' : '0'};
  height: ${prop => prop.open ? 'auto' : '0'};
  overflow: ${prop => prop.open ? '' : 'hidden'};
`;

export const ModalActionAddressContent = styled.div`
  width: 100%;
  max-width: 800px;
  background: ${colors.white};
  box-shadow: 0px 5px 10px ${colors.shadow};
  -webkit-box-shadow: 0px 5px 10px ${colors.shadow};
  -moz-box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 16px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ModalActionAddressHead = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: ${prop => prop.setShowModal ? '0' : '30px'};

  svg {
    cursor: pointer;
  }
`;

export const ModalActionAddressBodySelect = styled.div`
  display: inline-flex;
`;

export const ModalActionOtro = styled.div`
  display: flex;
  align-self: flex-end;
  margin-right: 20px;  
  flex-direction: column;
`;

export const ModalActionSign = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-right: 20px;  
`;

export const ModalActionAddressBody = styled.div`
  display: flex;
  justify-content: left;
  flex-direction: column;
  align-items: left;
`;

export const ModalActionAddressFooter = styled.div`
  display: flex;
  justify-content: right;
`;

export const ModalActionAddressBodyLabel = styled.p`
  text-align: left;
  margin-top: 30px;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.03em;
  color: ${colors.black};
`;

export const ModalActionAddressBodyDescription = styled.p`
  margin-top: 20px;
  max-width: 521px;
  font-size: 16px;
  line-height: 23px;
  color: ${colors.textPrimary};
  letter-spacing: 0.03em;
  text-align: left;
`;

export const SecondaryLargeButton = styled.button`
  margin-top: 20px;
  padding: 14px 32px;
  box-shadow: 0px 5px 10px ${colors.shadow};
  border-radius: 48px;
  border: 1px solid ${colors.bgSecondaryLight};
  color: ${colors.white};
  font-size: 14px;
  line-height: 21px;
  background: ${colors.bgSecondary};
  transition: ease-in-out .2s;
  font-weight: 600;
  letter-spacing: 0.03em;
  min-width: 158px;
  
  &:hover {
    background: ${colors.bgSecondaryHover};
    box-shadow: 0px 5px 15px ${colors.shadowHover};
  }
`;

export const InputDefaultField = styled.input`
  margin-top: 20px;
  border-radius: 8px;
  border: 1px solid ${colors.textSecondary};
  font-size: 14px;
  padding: 12px 10px;
  cursor: initial;
  transition: ease-in-out .2s;

  &:read-only {
    background: ${colors.readOnlyBorder};
    border: 1px solid ${colors.readOnlyBorder};
  }

  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${colors.textSecondary};
    opacity: 0.9;
    font-size: 14px;
    font-family: 'Montserrat', sans-serif;;
  }

  :-ms-input-placeholder {
    color: ${colors.textSecondary};
    opacity: 0.9;
    font-size: 14px;
    font-family: 'Montserrat', sans-serif;;
  }

  &.error {
    border-bottom: solid 5px${colors.bgDanger}; 
  }
`;
